import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/api/client";
import PropertyCard from "@/components/PropertyCard";
import SEO from "@/components/SEO";
import { Heart, MapPin } from "lucide-react";

export default function SharedFavoritesPage() {
  const { shareId } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setData(null); setNotFound(false);
    api.get(`/shared-favorites/${shareId}`).then((r) => setData(r.data)).catch(() => setNotFound(true));
  }, [shareId]);

  if (notFound) {
    return (
      <div className="container-cnp py-24 text-center">
        <h1 className="font-display text-3xl">Link não encontrado</h1>
        <p className="mt-3 text-stone-600">Esta partilha pode ter sido removida.</p>
        <Link to="/imoveis" className="btn-secondary mt-6 inline-flex">Ver imóveis</Link>
      </div>
    );
  }
  if (!data) return <div className="container-cnp py-24">A carregar...</div>;

  return (
    <div data-testid={`page-shared-favoritos-${shareId}`}>
      <SEO title={data.name ? `Lista de imóveis — ${data.name}` : "Lista partilhada"} description="Imóveis partilhados por casa no porto." />
      <section className="container-cnp pt-14 lg:pt-20 pb-8">
        <div className="tag-chip inline-flex items-center gap-1"><Heart className="h-3 w-3 fill-[#103C4A] text-[#103C4A]" /> Lista partilhada</div>
        <h1 className="mt-4 font-display text-4xl md:text-5xl text-stone-900">
          {data.name ? `Uma seleção para ${data.name}` : "Uma seleção de imóveis"}
        </h1>
        {data.note && <p className="mt-4 max-w-2xl text-stone-600 whitespace-pre-wrap">{data.note}</p>}
        <div className="mt-4 flex items-center gap-2 text-xs uppercase tracking-widest text-stone-500">
          <MapPin className="h-3 w-3" /> Porto e Grande Porto · casa no porto
        </div>
      </section>

      <section className="container-cnp pb-16">
        {data.properties.length === 0 ? (
          <div className="card-soft p-10 text-center text-stone-500">Estes imóveis já não estão disponíveis.</div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {data.properties.map((p) => <PropertyCard key={p.id} property={p} />)}
          </div>
        )}
      </section>

      <section className="container-cnp pb-24">
        <div className="card-soft p-8 text-center">
          <div className="text-stone-700">Gostou desta seleção? Fale com a Zélia.</div>
          <Link to="/contacto" className="btn-primary mt-4 inline-flex">Contactar a Zélia</Link>
        </div>
      </section>
    </div>
  );
}
